/**
 * Created by razial on 01.07.2024.
 */

const Dynamite = function (unit) { 
    UnitComponent.call(this, unit);
};

Dynamite.prototype = Object.create(UnitComponent.prototype);
Dynamite.prototype.constructor = Dynamite;

Dynamite.prototype.explode = function () {
    const affected = this.listAffectedUnits();

    Map2dLocation.currentLocation.counter.playActions([
        (f) => {
            this.unit.movable = false;

            cleverapps.effects.fire("merge.dynamite");

            if (this.view) {
                this.view.explode();
            }

            affected.forEach((unit) => {
                unit.setBlock(true);
            });
            f();
        },

        Map2dLocation.currentLocation.counter.createDelayAction(Dynamite.TIME_TO_EXPLODE),

        (f) => {
            affected.forEach((unit) => {
                unit.setBlock(false);
                if (unit.prizes) {
                    unit.takePrizes({ force: true });

                    if (unit.prizes) {
                        return;
                    }
                }

                const lock = unit.findComponent(LockedComponent);
                if (lock && lock.isLockActive()) {
                    lock.unlock();
                }

                const mineable = unit.findComponent(Mineable);
                const stages = mineable && mineable.countStages() || 0;

                for (let i = 0; i < stages; i++) {
                    if (!mineable.isCompleted()) {
                        mineable.completeMining();
                        unit.takePrizes({ force: true });
                    }
                }

                f();
            });

            this.unit.onDestruction();
            this.unit.remove(true);

            Map2dLocation.currentLocation.harvested.wantsToShowTip = false;
        }
    ]);
};

Dynamite.prototype.listAffectedUnits = function () {
    const units = [];

    const shape = Dynamite.calcExplosionShape(this.unit.getData().dynamite.radius);

    shape.forEach((part) => {
        const x = this.unit.x + part.x;
        const y = this.unit.y + part.y;

        let unit = Map2d.currentMap.getUnit(x, y);
        if (unit) {
            if (unit.head) {
                unit = unit.head;
            }

            if (units.indexOf(unit) !== -1) {
                return;
            }

            if (Dynamite.canExplodeUnit(unit)) {
                units.push(unit);
            }
        }
    });

    return units;
};

Dynamite.prototype.getActionInfo = function () {
    return {
        simpleInfo: true,
        title: {
            code: this.unit.code,
            stage: this.unit.stage,
            icon: true
        },
        buttons: {
            explode: {
                action: this.explode.bind(this)
            }
        }
    };
};

Dynamite.SHAPE_CACHE = {};

Dynamite.calcExplosionShape = function (radius) {
    if (Dynamite.SHAPE_CACHE[radius]) {
        return Dynamite.SHAPE_CACHE[radius];
    }

    const directions = [{ x: 1, y: 0 }, { x: -1, y: 0 }, { x: 0, y: 1 }, { x: 0, y: -1 }];
    const used = {};

    const queue = [{ x: 0, y: 0, r: 0 }];
    used[`${queue[0].x}_${queue[0].y}`] = true;

    for (let i = 0; i < queue.length; ++i) {
        const cell = queue[i];

        for (let j = 0; j < directions.length; ++j) {
            const direction = directions[j];
            const next = { x: cell.x + direction.x, y: cell.y + direction.y, r: cell.r + 1 };

            if (!used[`${next.x}_${next.y}`] && next.r <= radius) {
                used[`${next.x}_${next.y}`] = true;
                queue.push(next);
            }
        }
    }

    Dynamite.SHAPE_CACHE[radius] = queue;

    return queue;
};

Dynamite.canExplodeUnit = function (unit) {
    return unit && !Map2d.currentMap.workers.findAssigned(unit) && (unit.prizes || unit.findComponent(Mineable));
};

Dynamite.TIME_TO_EXPLODE = 1760;
